import {UIGameChat} from './UIGameChat/UIGameChat'
import {UIGameLog} from './UIGameLog/UIGameLog'
import React from 'react'
import styles from './UIGameFeeds.module.scss'
import {UIMutePlayerProvider} from '../../contexts/UIMutePlayerContext'

export interface UIGameFeedsProps {
    isChatEnabled: boolean
    onClickLog: (logIndex: number) => void
    onSendChat: (message: string) => void
    containerRef: React.Ref<HTMLDivElement> | null
    isChatDefaultMinimized?: boolean
}

export function UIGameFeeds({
    isChatEnabled,
    onClickLog,
    onSendChat,
    containerRef,
    isChatDefaultMinimized,
}: UIGameFeedsProps) {
    return (
        <UIMutePlayerProvider>
            <div className={styles.feedsContainer} ref={containerRef}>
                <div className={styles.responsiveContainer}>
                    <UIGameLog onClickLog={onClickLog} />
                    {isChatEnabled && <UIGameChat isDefaultMinimized={isChatDefaultMinimized} onSendChat={onSendChat}/>}
                </div>
            </div>
        </UIMutePlayerProvider>
    )
}
